import { InputGroup, InputGroupAddon, InputGroupInput } from "@/ds/shadcn/components/ui/input-group";
import { type LucideIcon } from "lucide-react";
import { createElement, type FC } from "react";

export interface HeaderBarInputProps {
	value: string;
	onChange: (value: string) => void;
	placeholder: string;
	icon?: LucideIcon;
}

export const HeaderBarInput: FC<HeaderBarInputProps> = props => {
	const {
		value,
		onChange,
		placeholder,
		icon
	} = props;

	return (
		<InputGroup className="w-full @md:min-w-24">
			<InputGroupInput className="text-sm" value={value} onChange={e => onChange(e.currentTarget.value)} placeholder={placeholder} />
			<InputGroupAddon>
				{icon && createElement(icon)}
			</InputGroupAddon>
		</InputGroup>
	);
};
